import React from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import { FaLeaf } from 'react-icons/fa';

import './Navbar.css';

const links = [
  { href: '#caffetteria', label: 'Caffetteria' },
  { href: '#pausa-pranzo', label: 'Pausa pranzo' },
  { href: '#aperitivi', label: 'Aperitivi' },
  { href: '#contatti', label: 'Contatti' },
];

const Navbar = () => {
  const [open, setOpen] = React.useState(false);
  const close = () => setOpen(false);

  React.useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open]);

  return (
    <header className="navbar">
      <div className="container navbar__bar">
        <a href="#home" className="navbar__brand" onClick={close}>
          <FaLeaf className="navbar__leaf" aria-hidden="true" />
          <span>L’angolo verde</span>
        </a>

        <nav className="navbar__nav" aria-label="Principale">
          <ul className="navbar__links">
            {links.map((link) => (
              <li key={link.href}>
                <a href={link.href}>{link.label}</a>
              </li>
            ))}
          </ul>
        </nav>

        <a href="#contatti" className="btn btn--primary navbar__cta">
          Vieni a trovarci
        </a>

        <button
          type="button"
          className="navbar__toggle"
          aria-expanded={open}
          aria-controls="menu-mobile"
          aria-label={open ? 'Chiudi il menu' : 'Apri il menu'}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <FiX aria-hidden="true" /> : <FiMenu aria-hidden="true" />}
        </button>
      </div>

      <nav
        id="menu-mobile"
        className={`navbar__panel${open ? ' navbar__panel--open' : ''}`}
        aria-label="Menu mobile"
      >
        <ul>
          {links.map((link) => (
            <li key={link.href}>
              <a href={link.href} onClick={close}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
        <a href="#contatti" className="btn btn--primary" onClick={close}>
          Vieni a trovarci
        </a>
      </nav>
    </header>
  );
};

export default Navbar;
